import { useApiUpdate } from '../../../../../lib/HttpService';
import { PATH } from './const';
import { StubbornData } from '../../../../../application/business';

export const useEditionAssetUpdate = () => useApiUpdate<StubbornData>(PATH);
